import { LatLng } from '../interfaces';

export const INVISIBLES = /[\u200B-\u200D\uFEFF\u200E\u200F\u202A-\u202E\u2060-\u2064\u206A-\u206F]/g;
export const stripInvisibles = (value?: string | null): string =>
  typeof value === 'string' ? value.replace(INVISIBLES, '') : '';

const INVISIBLE_HTML_ENTITIES: Record<string, string> = {
  ZeroWidthSpace: '',
  zerowidthspace: '',
  zwnj: '',
  zwj: '',
  lrm: '',
  rlm: '',
  NoBreak: '',
  nobreak: '',
  NoBreakSpace: ' ',
  nobreakspace: ' ',
};

const HTML_ENTITIES: Record<string, string> = {
  amp: '&',
  apos: "'",
  gt: '>',
  lt: '<',
  nbsp: ' ',
  quot: '"',
  ...INVISIBLE_HTML_ENTITIES,
};

const decodeHtmlEntities = (value: string): string =>
  value.replace(/&(#(?:x[\da-f]+|\d+)|[a-z][\da-z]+);/gi, (entity, code: string) => {
    if (code.startsWith('#x') || code.startsWith('#X')) {
      const characterCode = Number.parseInt(code.slice(2), 16);
      return Number.isFinite(characterCode) && characterCode >= 0 && characterCode <= 0x10ffff
        ? String.fromCodePoint(characterCode)
        : entity;
    }

    if (code.startsWith('#')) {
      const characterCode = Number.parseInt(code.slice(1), 10);
      return Number.isFinite(characterCode) && characterCode >= 0 && characterCode <= 0x10ffff
        ? String.fromCodePoint(characterCode)
        : entity;
    }

    return HTML_ENTITIES[code] ?? HTML_ENTITIES[code.toLowerCase()] ?? entity;
  });

export const normalizeAltText = (value?: string | null): string => {
  if (typeof value !== 'string') return '';

  let normalized = value;
  for (let index = 0; index < 3; index += 1) {
    const decoded = decodeHtmlEntities(normalized);
    if (decoded === normalized) break;
    normalized = decoded;
  }

  return stripInvisibles(normalized).replace(/\s+/g, ' ').trim();
};
export const VIMEO_REPLACE_PATTERN = /vimeo\.com\/(\d+)/;
export const VIMEO_EMBED_TEMPLATE = 'player.vimeo.com/video/$1';

export const itemsPerPageOptions = [
  { label: '12', value: 12 },
  { label: '25', value: 25 },
  { label: '50', value: 50 },
  { label: '100', value: 100 },
];

export const ITEM_ALIGNMENT = {
  left: 'left',
  center: 'center',
  right: 'right',
};

//Logo Wall
export const LOGO_SIZE = { width: 214, height: 110 } as const;
export const COMPONENT_POSITION = {
  POSITION_LEFT: 'left',
  POSITION_RIGHT: 'right',
  POSITION_CENTER: 'center',
};

export const INTERVAL_TIME = 5000; //5s

// Hard default: 483 George St, Sydney NSW 2000
export const SYD_TOWN_HALL: LatLng = { lat: -33.8732, lng: 151.2065 };

export const BUTTON_VARIANTS = ['primary', 'secondary', 'tertiary', 'text'] as const;

export const SANITY_TYPE = {
  GENERIC_PAGE: 'genericPage',
  STRUCTA_PRODUCT_LEVEL1: 'structaProductLevel1',
  STRUCTA_PRODUCT_LEVEL2: 'structaProductLevel2',
  STRUCTA_PRODUCT_LEVEL3: 'structaProductLevel3',
  PRODUCTS_LIST: 'productsList',
  PRODUCT: 'product',
  ARTICLE: 'article',
  DOCUMENT_PAGE: 'documentPage',
};

export const ERROR_LOCATION_CONTENT =
  'Your location can only be shown when location services are enabled and you are connected to the internet.';
